import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@unleash/proxy-client-react';

import { AppToggle } from '../../../clients/unleash/app-toggle-names';
import { useDirectAnswer } from '../../../redux/hooks/answer/direct-answers-hooks';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks/app-hooks';
import { openAskAiAddKnowledgeModal } from '../../../redux/thunks/ask-ai-kb-thunk';

import { isDirectAnswerReady } from './helper';

export const useAddKnowledgeButton = () => {
    const { t } = useTranslation('translations');
    const enabled = useFlag(AppToggle.ADD_KNOWLEDGE);
    const dispatch = useAppDispatch();
    const questionId = useAppSelector((state) => state.question.question_id);
    const { directAnswer, isLoading } = useDirectAnswer();

    const label = directAnswer?.is_answerable ? t('ask-ai-kb.validate-answer') : t('ask-ai-kb.add-to-kb');
    const directAnswerIsNotReady = isLoading || (!!directAnswer && !isDirectAnswerReady(directAnswer));

    const disabled = isLoading || !questionId || directAnswerIsNotReady;

    const onClick: React.MouseEventHandler = React.useCallback(
        (e) => {
            if (e instanceof MouseEvent) {
                e.stopPropagation();
            }

            if (disabled) {
                return;
            }

            const answer = !directAnswer?.is_answerable ? '' : directAnswer?.answer ?? '';

            dispatch(openAskAiAddKnowledgeModal({ answer }));
        },
        [directAnswer?.answer, directAnswer?.is_answerable, disabled, dispatch]
    );

    return {
        onClick,
        disabled,
        label,
        enabled,
    };
};
